import { useSearchParams } from 'react-router-dom';

const usePreserveQueryString = () => {
    const [searchParams] = useSearchParams();
    const queryString = searchParams.toString();

    return queryString ? `?${queryString}` : '';
};

export default usePreserveQueryString;
